<template>
  <div class="panel-print">
    <div class="panel-print__title">{{ title }}</div>
    <div class="panel-print__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelPrint',
  props: {
    title: String,
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .panel-print
    &__title
      background: var(--color-table-header-bg)
      font-weight: bold
      font-size: 1.2em
      padding: 2px 20px
      border-radius: 5px 5px 0 0
    &__body
      padding: 20px 0

  @media print
    .panel-print
      &__title
        margin-bottom: 5px
      &__body
        padding: 0 0

</style>
